import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Stack, TextField } from '@mui/material';
import { MeetingOutcomeScoreField } from '@modules/Meetings/partials/MeetingOutcomeScoreField';


type FormCrud = Feedback.Crud;

export const MeetingFeedbackForm: React.FC = () => {
  const { control } = useFormContext<FormCrud>();

  return (
    <Stack gap={2}>
      <MeetingOutcomeScoreField/>
      <Controller
        control={control}
        name="reflection"
        render={({ field, fieldState }) => (
          <TextField
            label="Meeting Reflection"
            placeholder="Share your thoughts about this meeting..."
            multiline
            minRows={3}
            value={field.value ?? ''}
            onChange={(e) =>
              field.onChange(e.target.value === '' ? null : e.target.value)
            }
            onBlur={field.onBlur}
            inputRef={field.ref}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />
    </Stack>
  );
};